import { render } from "./ViewchqPage.vue?vue&type=template&id=fa9926b4&ts=true"
import script from "./ViewchqPage.vue?vue&type=script&lang=ts"
export * from "./ViewchqPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__